var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9881 2.58238H11.1389V2.50387C11.1389 1.67461 10.3067 1 9.28379 1H6.71621C5.69328 1 4.86113 1.67461 4.86113 2.50387V2.58238H3.01186C2.4531 2.58238 2 2.94959 2 3.40267V4.02793C2 4.17896 2.15099 4.30136 2.33729 4.30136H13.6627C13.849 4.30136 14 4.17896 14 4.02793V3.40267C14 2.94959 13.547 2.58238 12.9881 2.58238ZM5.87299 2.50387C5.87299 2.12694 6.25125 1.82029 6.71621 1.82029H9.28379C9.74875 1.82029 10.127 2.12694 10.127 2.50387V2.58238H5.87299V2.50387Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43701 5.12207L3.25453 14.6185C3.27311 14.8334 3.49353 15.0001 3.75928 15.0001H12.2414C12.5071 15.0001 12.7275 14.8334 12.746 14.6185L13.5634 5.12207H2.43701ZM5.99801 13.6052C5.99077 13.6055 5.98339 13.6056 5.97614 13.6056C5.70671 13.6056 5.4826 13.4332 5.47114 13.2129L5.13385 6.78722C5.12186 6.5609 5.33859 6.3696 5.61778 6.35999C5.89709 6.3507 6.13293 6.52608 6.14478 6.7524L6.48207 13.178C6.49393 13.4044 6.2772 13.5956 5.99801 13.6052ZM8.50618 13.1954C8.50618 13.422 8.2797 13.6056 8.00025 13.6056C7.72081 13.6056 7.49432 13.422 7.49432 13.1954V6.76981C7.49432 6.54327 7.72081 6.35967 8.00025 6.35967C8.2797 6.35967 8.50618 6.54327 8.50618 6.76981V13.1954ZM10.5295 13.2129C10.5179 13.4333 10.2938 13.6056 10.0244 13.6056C10.0171 13.6056 10.0097 13.6055 10.0025 13.6053C9.72331 13.5957 9.50658 13.4044 9.51843 13.178L9.85572 6.7524C9.86771 6.52608 10.1039 6.35048 10.3827 6.36009C10.6619 6.36971 10.8786 6.5609 10.8668 6.78722L10.5295 13.2129Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.3d124529.svg";
export { ForwardRef as ReactComponent };